import React from 'react'
import { ServerConfig } from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'

// Staff / admin Support Entries management (PR > Support > FAQ Entries).
//
// Backend routes (views/support.py, admin_blueprint):
//   GET  /admin/support/entries        -> list (PaginatedList list_get_url)
//   POST /admin/support/entries        -> create (add_new_url)
//   PUT  /admin/support/entries/:id    -> update (detail_put_url + id)
//
// NOTE: there is no single GET /admin/support/entries/:id yet, so detail_get_url
// points at the same base for now. If PaginatedList needs a real detail fetch,
// add that route on the backend (it's the same serializer as the list).

const SupportEntries = () => {
  const editable_fields = [
    ["title", "Title"],
    ["status", "Status", "supportquestionstatus"],
    ["link_text", "Link text"],
    ["link_url", "Link URL"],
    ["image_url", "Image URL"],
    ["video_url", "Video URL"],    
    ["question", "Question", 'textarea', 2],
    ["answer", "Answer", 'textarea', 4],
    ["keywords", "Keywords", "keywords"],
    ["delete", "Delete", "delete"],
  ];

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/support/entries/`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/support/entries/detail/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/support/entries/detail/`}
        add_new_url={`${ServerConfig.SERVER_URL}/admin/support/entries`}

        column_names={["title", "status", "edit"]}
        header_names={["Title", "Status", ""]}

        optional_column_names={["question", "created_at", "updated_at"]}
        optional_header_names={["Question", "Created", "Updated"]}

        editable_fields={editable_fields}
      />
    </>
  )
}

export default SupportEntries